import { GridRowId } from '@mui/x-data-grid-premium'
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium'

export const isGroupRow = (apiRef: { current: GridApiPremium | null }, rowId: GridRowId) =>
  Boolean(String(rowId).match(/^auto-generated-row/)) || apiRef.current?.getRowNode(rowId)?.type === 'group'
